<ng-container *transloco="let t">
  <app-stats-overlay [checkAccountMarketplaceProperties]="false">
    <div class="flex flex-col gap-6">
      <app-metric-selector
        [data]="totalData"
        [previousPeriodData]="previousTotalData"
        [localStorageKey]="localStorageKey"
        [pageMetrics]="allMetrics"
        (chartMetricsChanges)="selectMetrics($event)"
        [setDetailedStats]="statsDisplayMode() !== StatDisplayMode.ALL"
      />
      @if (!isGlobalChartHidden) {
        <chart-layout
          closable
          withDateAggregation
          [emptyData]="(globalChartData$ | async)?.data?.length === 0"
          (aggregationChange)="selectAggregation($event)"
          (close)="toggleGlobalChartDisplay(true)"
        >
          <ng-container chart-actions>
            @if (displaySplitStatsMenu()) {
              <ISelect
                class="w-64"
                [options]="statDisplayModesOptions"
                [selectedValue]="statsDisplayMode()"
                (selectedOptionChange)="selectStatsDisplayMode($event.value)"
              />
            }
          </ng-container>
          <canvas
            baseChart
            class="chart mb-3"
            [datasets]="globalDataset.chartDataSet"
            type="line"
            [labels]="globalDataset.labels"
            [options]="globalDataset.lineChartOptions"
          ></canvas>
        </chart-layout>
      } @else {
        <div class="flex justify-end">
          <IButton
            [label]="t('agency-board.show_global_chart')"
            [icon]="ICON_CHART"
            color="white"
            (onClick)="toggleGlobalChartDisplay(false)"
          />
        </div>
      }

      <grid-layout
        withExport
        withRestoreColumns
        (onRestoreColumns)="restoreColumns()"
        [exportDropdownItems]="exportCsvDropdownItems"
      >
        <ag-grid-angular class="h-[45rem] w-full" [gridOptions]="gridOptions" [statusBar]="STATUS_BAR" />
      </grid-layout>
    </div>
  </app-stats-overlay>
</ng-container>
